const indexItems = [
  {
    title: '选秀内幕专题',
    desc: '全方位深挖各类选秀节目的不为人知的幕后故事与选手黑料',
    count: '47篇',
    img: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20mysterious%20silhouette%2C%20dark%20theatrical%20atmosphere%2C%20red%20curtains%20with%20golden%20trim%2C%20entertainment%20industry%20behind%20scenes%20vibe%2C%20cinematic%20photography%20with%20deep%20contrast&width=400&height=280&seq=index-01-2026&orientation=landscape',
  },
  {
    title: '电竞爆料专区',
    desc: '电竞赛事假赛、转会内幕、俱乐部纠纷一手资讯与深度分析',
    count: '53篇',
    img: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20dramatic%20blue%20and%20red%20neon%20lighting%2C%20gaming%20competition%20stage%2C%20cyberpunk%20aesthetic%20with%20dark%20moody%20tone%2C%20professional%20esports%20photography%2C%20cinematic%20wide%20shot&width=400&height=280&seq=index-02-2026&orientation=landscape',
  },
  {
    title: '综艺八卦汇总',
    desc: '热门综艺节目录制现场直击、嘉宾关系揭秘与争议事件整理',
    count: '61篇',
    img: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20set%20with%20colorful%20lighting%20and%20cameras%2C%20behind%20the%20scenes%20production%20aesthetic%2C%20entertainment%20studio%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20cinematic%20photography%20with%20professional%20look&width=400&height=280&seq=index-03-2026&orientation=landscape',
  },
  {
    title: '网红翻车实录',
    desc: '网红主播大赛数据造假、人设崩塌与行业灰色操作全纪录',
    count: '39篇',
    img: 'https://readdy.ai/api/search-image?query=Influencer%20streaming%20setup%20with%20dramatic%20red%20and%20pink%20lighting%2C%20social%20media%20culture%20aesthetic%2C%20dark%20room%20with%20ring%20light%20glow%2C%20modern%20content%20creator%20vibe%2C%20cinematic%20photography%20with%20moody%20tone&width=400&height=280&seq=index-04-2026&orientation=landscape',
  },
  {
    title: '每日吃瓜日报',
    desc: '按日整理的每日大赛黑料精选合集，不错过任何一条劲爆内容',
    count: '186篇',
    img: 'https://readdy.ai/api/search-image?query=Newspaper%20and%20digital%20tablet%20on%20dark%20desk%20with%20dramatic%20lighting%2C%20daily%20news%20aesthetic%2C%20journalism%20vibe%20with%20warm%20glow%2C%20modern%20media%20consumption%20scene%2C%20cinematic%20photography%20with%20deep%20shadows&width=400&height=280&seq=index-05-2026&orientation=landscape',
  },
  {
    title: '深度调查系列',
    desc: '每日大赛黑料原创调查报道，用事实说话还原争议事件真相',
    count: '28篇',
    img: 'https://readdy.ai/api/search-image?query=Investigation%20desk%20with%20documents%20and%20magnifying%20glass%20in%20dramatic%20lighting%2C%20detective%20noir%20aesthetic%2C%20mystery%20solving%20atmosphere%2C%20warm%20amber%20desk%20lamp%2C%20cinematic%20photography%20with%20deep%20contrast&width=400&height=280&seq=index-06-2026&orientation=landscape',
  },
  {
    title: '吃瓜群众热议',
    desc: '社区最活跃的讨论话题，看吃瓜群众如何解读各大黑料事件',
    count: '215篇',
    img: 'https://readdy.ai/api/search-image?query=Crowd%20discussion%20scene%20with%20dramatic%20warm%20lighting%2C%20community%20conversation%20aesthetic%2C%20people%20talking%20in%20dark%20atmospheric%20setting%2C%20social%20gathering%20vibe%2C%20cinematic%20photography%20with%20golden%20highlights&width=400&height=280&seq=index-07-2026&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            每日大赛黑料精华内容分类索引，按专题浏览大赛吃瓜资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {indexItems.map((item, i) => (
            <article
              key={i}
              className={`rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer ${
                i === 0 ? 'sm:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-background-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.count}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}